export const convertToRad = (deg: number) => (deg * Math.PI) / 180;

/**
 * Normalizes an angle to the range [0, 360)
 * @param a Angle in degrees
 * @returns Normalized angle in degrees
 */
export const normalizeDegreeAngleRange = (a: number) => ((a % 360) + 360) % 360;

export const getLeftOffset = (
  angleDeg: number,
  width: number,
  height: number
) => {
  const angleRad = convertToRad(angleDeg);
  return (
    Math.max(Math.sin(angleRad), 0) * height +
    Math.max(-Math.cos(angleRad), 0) * width
  );
};

export const getRightExtent = (
  angleDeg: number,
  width: number,
  height: number
) => {
  const angleRad = convertToRad(angleDeg);
  return (
    Math.max(Math.cos(angleRad), 0) * width +
    Math.max(-Math.sin(angleRad), 0) * height
  );
};

export const getTopOffset = (
  angleDeg: number,
  width: number,
  height: number
) => {
  const angleRad = convertToRad(angleDeg);
  return (
    Math.max(-Math.sin(angleRad), 0) * width +
    Math.max(-Math.cos(angleRad), 0) * height
  );
};

export const getBottomExtent = (
  angleDeg: number,
  width: number,
  height: number
) => {
  const angleRad = convertToRad(angleDeg);
  return (
    Math.max(Math.sin(angleRad), 0) * width +
    Math.max(Math.cos(angleRad), 0) * height
  );
};

export const getRelativeCenter = (
  angle: number | undefined,
  width: number,
  height: number
) => {
  const a = angle ? convertToRad(normalizeDegreeAngleRange(angle)) : 0;
  const cos = Math.cos(a);
  const sin = Math.sin(a);

  const corners = [
    { x: 0, y: 0 },
    { x: width, y: 0 },
    { x: 0, y: height },
    { x: width, y: height },
  ];

  const rotated = corners.map((c) => ({
    x: c.x * cos - c.y * sin,
    y: c.x * sin + c.y * cos,
  }));

  const minX = Math.min(...rotated.map((p) => p.x));
  const maxX = Math.max(...rotated.map((p) => p.x));
  const minY = Math.min(...rotated.map((p) => p.y));
  const maxY = Math.max(...rotated.map((p) => p.y));

  return {
    x: (minX + maxX) / 2,
    y: (minY + maxY) / 2,
  };
};
